import { Image, ImageProps } from '@chakra-ui/react'
import React from 'react'
import src from './person.svg'

export const PatientIcon = (props: ImageProps) => (
  <Image mr={1} width="18px" filter="grayscale(100%) brightness(3)" src={src} {...props} />
)
